import { UserDto } from './dto/userDto';
import { User } from '@shared/domain/user/user.aggregate';
import { httpClient } from '@shared/infrastructure/http/http';
import { configuration } from 'configuration';

export const userRepositoryImplementation = {
  getUsers: async (): Promise<Array<User>> => {
    const response = await httpClient.get<Array<UserDto>>(
      `${configuration.api.baseUrl}/api/users`
    );

    return response as Array<User>;
  }
};
